import { useInScopeModel, useWatchableValue } from '../actions/framework';
import { useTabParams } from '../tab-manager/tab-manager';
import { GraphModel } from '../graph/graph.model';
import { Assert } from '@cotera/utilities';
import { ExpressionColumnEdit } from './expression/expression.edit';
import { LlmColumnEdit } from './llm/llm.edit';
import { EditTaxonomyColumn } from './taxonomy/edit';
import { NotFoundTab } from '../not-found.tab';
import { EditToolCallColumn } from './tool-call/tool-call.edit';
import { useTrackRecentActivity } from '../hooks/use-track-recent-activity';

export const EditColumnRouter: React.FC = () => {
  const { id: dataset, columnId } = useTabParams<{
    id: string;
    columnId: string;
  }>();

  const graphModel = useInScopeModel(GraphModel);

  const graph = useWatchableValue(graphModel.graph);

  const compiledColumn =
    graph.getColumn({
      rel: dataset,
      name: columnId,
    })?.builtNode ?? null;

  // Track column view
  useTrackRecentActivity({
    type: 'column',
    datasetName: dataset,
    columnName: columnId,
  });

  if (compiledColumn === null) {
    return (
      <NotFoundTab title="Column Not Found" resource={`Column "${columnId}"`} />
    );
  }

  switch (compiledColumn.meta.t) {
    case 'eraql': {
      const expr = compiledColumn.meta.expr;

      if (expr.ast.t === 'categorize') {
        return <EditTaxonomyColumn />;
      }

      return <ExpressionColumnEdit />;
    }

    case 'llm':
      return <LlmColumnEdit />;

    case 'workflow':
      return <EditToolCallColumn />;

    default:
      return Assert.unreachable(compiledColumn.meta);
  }
};
